function formatImageUrl(image) {
    // Check if image and variant_img_url exist
    if (!image || !image.variant_img_url) {
        console.warn('Invalid image object or missing variant_img_url');
        return '';
    }
    
    const urlParts = image.variant_img_url.split("/images/");
    
    // Check if the URL contains "/images/" and has the expected structure
    if (urlParts.length !== 2) {
        console.warn('Invalid image URL format:', image.variant_img_url);
        return image.variant_img_url; // Return original URL as fallback
    }
    
    const [baseUrl, imagePath] = urlParts;
    
    // Check if imagePath exists and has the expected structure
    if (!imagePath) {
        console.warn('Empty image path in URL:', image.variant_img_url);
        return image.variant_img_url; // Return original URL as fallback
    }
    
    const pathParts = imagePath.split("/");
    
    // Check if pathParts has at least one element
    if (pathParts.length === 0 || !pathParts[0]) {
        console.warn('Invalid image path structure:', imagePath);
        return image.variant_img_url; // Return original URL as fallback
    }
    
    const updatedPath = imagePath.replace(pathParts[0], "w_200,h_200,c_fit");
    return `${baseUrl}/images/${updatedPath}`;
}

function generateImageElement(image, className) {
    const img = document.createElement('img');
    img.classList.add(className, 'lazyautosizes', 'lazyloaded', 'hover');
    img.width = 100;
    img.height = 100;
    img.dataset.sizes = "auto";
    img.src = formatImageUrl(image);
    img.alt = image.variant_img_alttext;
    img.sizes = "70px";
    return img;

}

function generateNoscriptElement(image) {
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.width = 100;
    img.height = 100;
    img.sizes = "auto";
    img.src = formatImageUrl(image);
    img.alt = image.variant_img_alttext;
    img.loading = "lazy";
    noscript.appendChild(img);
    return noscript;
}

function generateProductCard(product, color) {
    const { id, title, variant, handle, priceRangeV2 } = product;
    const { price, images, variantId } = variant;
    const section_id = `template--${variantId}-product`;

    // Create main container elements
    const container = document.createElement('li');
    container.classList.add('column');

    const productCard = document.createElement('product-card');
    productCard.classList.add('product-card', 'text-center');

    // Create product image section
    const figure = document.createElement('figure');
    figure.classList.add('product-featured-image', 'thb-hover');

    const imageLink = document.createElement('a');
    Object.assign(imageLink, {
        href: '#',
        title: title,
        className: 'product-featured-image-link aspect-ratio aspect-ratio--adapt',
        style: '--padding-bottom: 100.0%'
    });

    // Add image and quick view button
    imageLink.appendChild(generateImageElement(images[0], 'product-primary-image--lazy'));
    imageLink.appendChild(generateNoscriptElement(images[0]));

    const quickViewBtn = document.createElement('button');
    Object.assign(quickViewBtn, {
        className: 'product-card-quickview',
        tabIndex: -1,
        href: '#Product-Drawer'
    });
    quickViewBtn.dataset.productHandle = handle;
    quickViewBtn.dataset.color = color;

    const loadingOverlay = document.createElement('div');
    loadingOverlay.className = 'loading-overlay';
    loadingOverlay.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewbox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-accent)"></circle></svg>';

    const quickViewText = document.createElement('span');
    quickViewText.textContent = 'Quick view';

    quickViewBtn.append(loadingOverlay, quickViewText);
    imageLink.appendChild(quickViewBtn);
    figure.appendChild(imageLink);

    // Create product info section
    const infoDiv = document.createElement('div');
    infoDiv.className = 'product-card-info';

    const titleLink = document.createElement('a');
    Object.assign(titleLink, {
        href: `/products/${handle}?variant=${variantId}`,
        title: title,
        className: 'product-card-title',
        textContent: title
    });

    const priceSpan = document.createElement('span');
    priceSpan.className = 'price';

    const priceIns = document.createElement('ins');
    const priceAmount = document.createElement('span');
    priceAmount.className = 'amount';
    priceAmount.innerHTML = `<span class="from">From </span>${priceRangeV2.minVariantPrice.currencyCode} ${price}`;
    priceIns.appendChild(priceAmount);
    priceSpan.appendChild(priceIns);

    // Create product form
    const productForm = document.createElement('product-form');
    productForm.className = 'spf-product-form';
    productForm.dataset.section = section_id;

    const errorWrapper = document.createElement('div');
    Object.assign(errorWrapper, {
        className: 'product-form__error-message-wrapper form-notification error',
        role: 'alert',
        hidden: ''
    });
    errorWrapper.appendChild(document.createElement('span')).className = 'product-form__error-message';
    productForm.appendChild(errorWrapper);

    const form = document.createElement('form');
    Object.assign(form, {
        id: `product-form-${section_id}`,
        className: 'spf-product__form',
        action: '/cart/add',
        method: 'post'
    });

    const variantInput = document.createElement('input');
    Object.assign(variantInput, {
        name: 'id',
        type: 'hidden',
        value: variantId
    });

    const addToCartBtn = document.createElement('button');
    Object.assign(addToCartBtn, {
        type: 'submit',
        className: 'spf-product__add-to-cart',
        textContent: 'Add'
    });

    form.append(variantInput, addToCartBtn);
    productForm.appendChild(form);

    // Assemble all components
    infoDiv.append(titleLink, priceSpan, productForm);
    productCard.append(figure, infoDiv);
    container.appendChild(productCard);

    return container;
}

function loadGWWProducts(tag, color) {
    document.getElementById('filtered-products').innerHTML = '';
    fetch(`https://jqueen.hyquality.com/api/products/${tag}/${color}/250`).then(response => response.text()).then((responseText) => {
        //parse response text to JSON
        const products = JSON.parse(responseText);
        //loop through products
        document.getElementById('filtered-products').classList.add('filtered-products--active');
        const ul = document.createElement('ul');
        const div = document.createElement('div');
        const sdiv = document.createElement('div');
        //check if products is empty and hide filtered-products
        if (products.length === 0) {
            document.getElementById('filtered-products').style.display = 'none';
            return;
        }
        products.forEach(product => {
            //generate product card
            if(document.querySelector('.product-title-container .product-title').textContent!==product.title){
                const card = generateProductCard(product,color);
                //append card to filtered-products
                ul.appendChild(card);
            }

        });
        //check if ul has children and append to filtered
        if (ul.children.length === 0) {
            document.getElementById('filtered-products').style.display = 'none';
            return;
        }
        div.classList.add('wrapper');
        sdiv.classList.add('slider-container');
        div.appendChild(ul);
        sdiv.appendChild(div);
        document.getElementById('filtered-products').appendChild(sdiv);
        createProductSlider()
    });
}

function createProductSlider() {
    const sliderContainer = document.getElementById('filtered-products');
    const productList = sliderContainer.querySelector('ul');
    const items = productList.querySelectorAll('li');
    
    // Create navigation buttons
    const prevButton = document.createElement('button');
    prevButton.classList.add('slider-nav', 'prev-button');
    prevButton.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.92125 7.5L7.7135 13.2923L7 14L0 7L7 0L7.7135 0.70775L1.92125 6.5H14V7.5H1.92125Z" fill="#151515"/></svg>';
    
    const nextButton = document.createElement('button');
    nextButton.classList.add('slider-nav', 'next-button');
    nextButton.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.0788 7.5H0V6.5H12.0788L6.2865 0.70775L7 0L14 7L7 14L6.2865 13.2923L12.0788 7.5Z" fill="#151515"/></svg>';

    
    // Create pagination container
    const paginationContainer = document.createElement('div');
    paginationContainer.classList.add('slider-pagination');
    
    // Calculate items per page and total pages
    const itemsPerPage = 1;
    const totalPages = items.length;
    
    // Create pagination dots
    for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('span');
        dot.classList.add('pagination-dot');
        if (i === 0) dot.classList.add('active');
        dot.dataset.page = i;
        paginationContainer.appendChild(dot);
    }
    
    // Add navigation buttons and pagination to container
    sliderContainer.appendChild(prevButton);
    sliderContainer.appendChild(nextButton);
    sliderContainer.appendChild(paginationContainer);
    
    let currentPage = 0;
    let touchStartX = 0;
    let touchEndX = 0;
    let isDragging = false;
    let startTranslate = 0;
    let currentTranslate = 0;
    
    // Function to update slider position
    function updateSlider(animate = true) {
        const translateX = -currentPage * 100;
        productList.style.transition = animate ? 'transform 0.3s ease' : 'none';
        productList.style.transform = `translateX(${translateX}%)`;
        
        // Update active pagination dot
        document.querySelectorAll('.pagination-dot').forEach((dot, index) => {
            dot.classList.toggle('active', index === currentPage);
        });
        
        // Update button states
        prevButton.disabled = currentPage === 0;
        nextButton.disabled = currentPage === totalPages - 1;
    }
    
    // Touch event handlers
    function handleTouchStart(e) {
        touchStartX = e.touches[0].clientX;
        isDragging = true;
        startTranslate = -currentPage * 100;
        currentTranslate = startTranslate;
        productList.style.transition = 'none';
    }
    
    function handleTouchMove(e) {
        if (!isDragging) return;
        
        const currentX = e.touches[0].clientX;
        const diff = currentX - touchStartX;
        const translateX = startTranslate + (diff / sliderContainer.offsetWidth * 100);
        
        // Limit the drag to prevent over-dragging
        if (translateX > 0 || translateX < -(totalPages - 1) * 100) return;
        
        currentTranslate = translateX;
        productList.style.transform = `translateX(${translateX}%)`;
    }
    
    function handleTouchEnd(e) {
        if (!isDragging) return;
        
        isDragging = false;
        touchEndX = e.changedTouches[0].clientX;
        const diff = touchEndX - touchStartX;
        const threshold = sliderContainer.offsetWidth * 0.2; // 20% threshold
        
        if (Math.abs(diff) > threshold) {
            if (diff > 0 && currentPage > 0) {
                currentPage--;
            } else if (diff < 0 && currentPage < totalPages - 1) {
                currentPage++;
            }
        }
        
        updateSlider(true);
    }
    
    // Add touch event listeners
    productList.addEventListener('touchstart', handleTouchStart, { passive: true });
    productList.addEventListener('touchmove', handleTouchMove, { passive: true });
    productList.addEventListener('touchend', handleTouchEnd);
    
    // Add click handlers for navigation buttons
    prevButton.addEventListener('click', () => {
        if (currentPage > 0) {
            currentPage--;
            updateSlider(true);
        }
    });
    
    nextButton.addEventListener('click', () => {
        if (currentPage < totalPages - 1) {
            currentPage++;
            updateSlider(true);
        }
    });
    
    // Add click handlers for pagination dots
    paginationContainer.addEventListener('click', (e) => {
        const dot = e.target.closest('.pagination-dot');
        if (dot) {
            currentPage = parseInt(dot.dataset.page);
            updateSlider(true);
        }
    });

    
    // Initialize slider
    updateSlider(false);
}